







import {
  defineComponent, onMounted, useRouter, PropType,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductTrustmateStars',
  props: {
    productSKU: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup({ productSKU }: { productSKU: string }) {
    const router = useRouter();
    const loadScriptOnLoad = () => {
      if (router.currentRoute.query.no_script) return;
      const temp = document.createElement('script');
      temp.setAttribute('src', `https://trustmate.io/widget/api/cc5dbcc3-c51d-4b09-adfd-2e62b9b2c528/script?product=${productSKU}`);
      document.head.append(temp);
    };
    onMounted(() => {
      loadScriptOnLoad();
    });
  },
});
